import { useEffect, useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5001';

// Module-scope cache so navigating between pages within a session doesn't
// re-hit the backend. Backend has its own 30-min TTL on top of this.
let memCache = null;
let memCacheAt = 0;
const MEM_TTL_MS = 5 * 60 * 1000; // 5 minutes in-tab

export function useTeamEventCounts() {
  const [data, setData] = useState(memCache);
  const [loaded, setLoaded] = useState(memCache != null);

  useEffect(() => {
    if (memCache && Date.now() - memCacheAt < MEM_TTL_MS) {
      setData(memCache);
      setLoaded(true);
      return;
    }

    let cancelled = false;
    fetch(`${BACKEND_URL}/api/teams/event-counts`)
      .then(r => (r.ok ? r.json() : null))
      .then(json => {
        if (cancelled) return;
        if (json?.counts) {
          memCache = json;
          memCacheAt = Date.now();
        }
        setData(json || { counts: {} });
        setLoaded(true);
      })
      .catch(() => {
        if (cancelled) return;
        setData({ counts: {} });
        setLoaded(true);
      });

    return () => { cancelled = true; };
  }, []);

  // Return a stable .lookup helper so callers don't have to know the
  // backend's normalization scheme (lowercased, trimmed).
  return {
    counts: data?.counts || {},
    loaded,
    generatedAt: data?.generatedAt || 0,
    lookup: (teamName) => {
      if (!teamName || !data?.counts) return null;
      const key = teamName.toLowerCase().trim();
      return data.counts[key] ?? null;
    },
  };
}
